window.FilterShared = window.FilterShared || (() => {
  function pickSectionHtmlFromJson(parsed, requestedId) {
    if (!parsed || typeof parsed !== 'object') return null;
    // Shopify ?sections= responses are keyed by section id at root.
    const map =
      parsed.sections != null && typeof parsed.sections === 'object' && !Array.isArray(parsed.sections)
        ? parsed.sections
        : parsed;
    const pick = (obj, id) => {
      const value = obj[id];
      return typeof value === 'string' && value.length > 0 ? value : null;
    };
    let html = pick(map, requestedId);
    if (html) return html;
    html = pick(map, 'main');
    if (html) return html;
    const key = Object.keys(map).find((k) => pick(map, k));
    return key ? map[key] : null;
  }

  function fetchSectionAwareHtml(url, sectionId, signal, label) {
    const sectionUrl = new URL(url, window.location.origin);
    sectionUrl.searchParams.set('sections', sectionId);

    return fetch(sectionUrl.toString(), { signal })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`${label} HTTP ${response.status}`);
        }
        return response.text();
      })
      .then((responseText) => {
        const trimmed = responseText.trim();
        if (!trimmed.startsWith('{')) {
          return responseText;
        }

        let parsed;
        try {
          parsed = JSON.parse(trimmed);
        } catch {
          return responseText;
        }

        const sectionHtml = pickSectionHtmlFromJson(parsed, sectionId);
        if (typeof sectionHtml === 'string' && sectionHtml.length > 0) {
          return sectionHtml;
        }

        return fetch(url, { signal }).then((fullResponse) => {
          if (!fullResponse.ok) {
            throw new Error(`${label} HTTP ${fullResponse.status}`);
          }
          return fullResponse.text();
        });
      });
  }

  function setGridLoadingState(gridId, isLoading) {
    const grid = document.getElementById(gridId);
    if (!grid) return;
    grid.toggleAttribute('data-loading', Boolean(isLoading));
    grid.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  }

  function bindPaginationLinkEvents(boundManagePagination) {
    document.querySelectorAll('a[data-pagination]').forEach((link) => {
      link.removeEventListener('click', boundManagePagination);
      link.addEventListener('click', boundManagePagination);
    });
  }

  function refreshCardActionButtons(quickshop, gridSelector) {
    if (quickshop && typeof quickshop.updateEvents === 'function') {
      quickshop.updateEvents();
    }

    if (window._swat && typeof window._swat.initializeActionButtons === 'function') {
      window._swat.initializeActionButtons(gridSelector);
    }
  }

  function scrollToResultsTop(primarySelector, fallbackSelector, behavior) {
    const target = document.querySelector(primarySelector) || document.querySelector(fallbackSelector);
    if (!target) return;
    const top = Math.max(target.getBoundingClientRect().top + window.pageYOffset - 24, 0);
    window.scrollTo({ top, behavior: behavior || 'auto' });
  }

  return {
    fetchSectionAwareHtml,
    setGridLoadingState,
    bindPaginationLinkEvents,
    refreshCardActionButtons,
    scrollToResultsTop,
  };
})();
